<template>
  <div class="memberCenter_wrap ContactsChange">
    <div class="nav_pos mb_nav_pos">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>
          <router-link to="/MemberCenter">首页</router-link>
        </el-breadcrumb-item>
        <el-breadcrumb-item>修改账号信息</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="back_btn" @click="back">
        返回
        <img src="@/assets/img/icon_return.png" alt />
      </div>
    </div>
    <div class="content_wrap" :style="{ height }">
      <div class="change_form_1">
        <div class="title">修改账号信息</div>
        <el-form :model="form" :rules="rules" ref="form" class="rule_form">
          <el-form-item label="用户名：" prop="Contact" label-width="130px">
            <el-input v-model="form.LoginName" placeholder="请输入用户名" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="注册电子邮箱：" prop="Email" label-width="130px">
            <el-input v-model="form.Email"></el-input>
          </el-form-item>
          <el-form-item label="注册手机号：" prop="Mobile" label-width="130px">
            <el-input v-model="form.Mobile" placeholder="请输入手机号码后，获取验证码"></el-input>
            <div class="msg_code1" @mousedown.stop="getCode()" :class="{ disabled }">{{ codeName }}</div>
          </el-form-item>
          <el-form-item label="短信验证码：" prop="AuthCode" label-width="130px">
            <el-input v-model="form.AuthCode" placeholder="请输入手机验证码"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="btn_wrap">
        <span class="btn_1" @click="reflash">重 置</span>
        <span class="btn_1" @click="submit">确 定</span>
      </div>
    </div>
  </div>
</template>

<script>
import { validateEmail, validatemobile } from '@/assets/js/util'
export default {
  inject: ['reload'],
  data() {
    return {
      validateMobile: '',
      height: document.body.clientHeight - 120 + 'px',
      codeName: '短信获取验证码',
      disabled: false,
      time: 0,
      timer: '',
      form: {
        value: '',
        region: []
      },
      rules: {
        AuthCode: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
        Mobile: [{ required: true, message: '', trigger: 'blur' }],
        Email: [{ required: true, validator: validateEmail, trigger: 'blur' }]
      }
    }
  },
  computed: {
    Mobile() {
      return this.form.Mobile
    }
  },
  watch: {
    Mobile(newVal, oldVal) {
      if (newVal == this.validateMobile) {
        delete this.rules.Mobile[0].validator
      } else {
        this.rules.Mobile[0].validator = validatemobile
      }
      if (newVal != oldVal && oldVal != null) {
        this.form.AuthCode = ''
        clearInterval(this.timer)
        this.codeName = '短信获取验证码'
        this.disabled = false
      }
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    back() {
      this.$router.push('/MemberCenter')
    },
    Mobilechange() {
      console.log('1212')
      this.form.AuthCode = ''
    },
    getData() {
      this.getRequest('SupplierLogin/AccountDataEdit', {}).then((res) => {
        if (res.data.errcode == 0) {
          this.form = res.data.data
          this.validateMobile = res.data.data.Mobile
          this.rules.Mobile[0].validator = ''
        } else {
          this.$message.error(res.data.errmsg)
        }
      })
    },

    getCode() {
      if (!this.disabled) {
        this.$refs['form'].validateField('Mobile', (valid) => {
          if (!valid) {
            this.postRequest('SupplierLogin/SendValidateCode', {
              mobile: this.form.Mobile,
              loginName: this.form.LoginName,
              type: 1
            }).then((res) => {
              if (res.data.errcode == 0) {
                this.time = res.data.disabledTime

                this.timer = setInterval(() => {
                  this.disabled = true
                  if (this.time == 0) {
                    this.codeName = '短信获取验证码'
                    clearInterval(this.timer)
                    this.disabled = false
                  } else {
                    this.codeName = '重新发送(' + this.time + ')'
                    this.time--
                  }
                }, 1000)
              } else {
                this.$message.error(res.data.errmsg)
              }
            })
          }
        })
      }
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.postRequest('SupplierLogin/AccountDataSave', {
            accountDataJson: JSON.stringify(this.form)
          })
            .then((res) => {
              if (res.data.errcode == 0) {
                this.$message({ type: 'success', message: '修改成功！' })
                this.$router.push('/MemberCenter')
              } else {
                this.$message.error(res.data.errmsg)
              }
            })
            .catch(function (error) {
              console.log(error)
            })
        }
      })
    },
    reflash() {
      this.reload()
    }
  }
}
</script>

<style lang="scss" scoped>
.ContactsChange {
  ::v-deep .el-form {
    margin: 15px;
  }
  .btn_wrap {
    width: 366px;
    margin: 60px auto 0;
    .btn_1 {
      background: #0774d7;
      color: #fff;
      border: none;
      border-radius: 10px;
    }
  }
}
.back_btn {
  height: 26px;
  bottom: 7px;
  padding: 0 18px;
  border-radius: 14px;
}
.msg_code {
  background: #fff;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 115px;
  display: inline-block;
  border-radius: 25px;
  padding: 0 10px;
  border: 1px solid #a3bed6;
  color: #5a8cb7;
  cursor: pointer;
}
.change_form_1 .title {
  display: block !important;
  height: 40px;
  line-height: 40px;
  margin: 0 5px;
  padding-left: 5px;
  font-size: 16px;
  font-weight: bold;
  color: #333333;
  border-bottom: 1px solid #95c7f0;
}
.msg_code1 {
  background: #fff;
  position: absolute;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  right: -132px;
  display: inline-block;
  border-radius: 25px;
  padding: 0 10px;
  border: 1px solid #a3bed6;
  color: #5a8cb7;
  cursor: pointer;
}
</style>
